import { useState } from "react";
import { Link } from "react-router-dom";
import authAPI from "../../../services/authApi";
import { getApiErrorMessage } from "../../../utils/apiError";
import PlatformAuthShell from "../../Clinic/Auth/PlatformAuthShell";
import AuthField from "../../Clinic/Auth/AuthField";
import Button from "../../ui/Button";
import AuthButtonLink from "../../Clinic/Auth/AuthButtonLink";
import a from "../../Clinic/Auth/auth.module.css";

export default function OwnerForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devUrl, setDevUrl] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await authAPI.forgotOwnerPassword(email.trim());
      if (r.result === 0) {
        setSent(true);
        if (r.devResetUrl) setDevUrl(r.devResetUrl);
      } else {
        setErr(r.message || r.error || "Ошибка");
      }
    } catch (error) {
      setErr(getApiErrorMessage(error, "Не удалось отправить запрос"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PlatformAuthShell
      backTo="/account/login"
      backLabel="К входу"
      title={sent ? "Проверьте почту" : "Сброс пароля"}
      subtitle={
        sent
          ? "Ссылка для сброса пароля отправлена на указанный email."
          : "Укажите email кабинета владельца — пришлём ссылку для нового пароля."
      }
      stepCurrent={sent ? 2 : 1}
      stepTotal={2}
      stepLabels={["Email", "Готово"]}
    >
      {sent ? (
        <>
          {devUrl ? (
            <p className={a.infoBox}>
              Dev: <a href={devUrl}>ссылка</a>
            </p>
          ) : null}
          <div className={a.actions}>
            <AuthButtonLink to="/account/login">К входу</AuthButtonLink>
          </div>
        </>
      ) : (
        <form onSubmit={submit}>
          {err ? <div className={a.errorBox}>{err}</div> : null}
          <AuthField
            label="Email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className={a.actions}>
            <Button type="submit" block size="lg" disabled={loading}>
              {loading ? "Отправка…" : "Отправить"}
            </Button>
          </div>
          <p className={a.footerLinks} style={{ marginTop: 16, textAlign: "center" }}>
            Вспомнили пароль?{" "}
            <Link to="/account/login">
              <span>Войти</span>
            </Link>
          </p>
        </form>
      )}
    </PlatformAuthShell>
  );
}
